(function(angular, module) {var OutcomeTypeReportBaseController, OutcomeTypeReportService, OutcomeTypeTotalsReportController, OutcomeTypes, outcomeTypeStates, resolveGlobalConfig,
  bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; };

OutcomeTypes = {
  job: {
    label: "Job Placement Types",
    column: 'job_type'
  },
  education: {
    label: "Education Placement Types",
    column: 'institution_type'
  },
  certificate: {
    label: "Certificate Types",
    column: 'certificate_name'
  }
};

outcomeTypeStates = function($stateProvider, TagUrl) {
  'ngInject';
  var programUrl, url;
  url = new TagUrl().addTagTypes(['program', 'location', 'participant']).setTagDefault('affiliation', 'all').addExtraParam('page', {
    type: 'int',
    value: 1,
    squash: true
  }).addExtraParam('sort', 'name');
  programUrl = new TagUrl().addTagTypes(['participant']).setTagDefault('affiliation', 'all').addExtraParam('page', {
    type: 'int',
    value: 1,
    squash: true
  }).addExtraParam('sort', 'name');
  $stateProvider.state('reports.outcomeType', {
    url: url.buildUrl('/:outcome-types'),
    reloadOnSearch: false,
    data: {
      tagUrl: url,
      outcomes: OutcomeTypes
    },
    params: url.params,
    abstract: true,
    templateUrl: 'reports/outcomeTypes/base',
    controller: 'OutcomeTypeReportBaseController',
    controllerAs: '$ctrl',
    resolve: {
      program: function() {
        return null;
      }
    }
  });
  $stateProvider.state('reports.outcomeType.totals', {
    url: '/{value}',
    reloadOnSearch: false,
    params: {
      value: {
        squash: true
      }
    },
    templateUrl: 'reports/outcomeTypes/totals',
    controller: 'OutcomeTypeTotalsReportController',
    controllerAs: '$ctrl',
    resolve: {
      config: resolveGlobalConfig
    }
  });
  $stateProvider.state('program.reports.outcomeType', {
    url: programUrl.buildUrl('/:outcome-types'),
    abstract: true,
    params: programUrl.params,
    reloadOnSearch: false,
    data: {
      tagUrl: programUrl,
      outcomes: OutcomeTypes,
      tagRefreshInject: ["program"]
    },
    templateUrl: 'reports/outcomeTypes/base',
    controller: 'OutcomeTypeReportBaseController',
    controllerAs: '$ctrl'
  });
  return $stateProvider.state('program.reports.outcomeType.totals', {
    url: '/{value}',
    reloadOnSearch: false,
    params: {
      value: {
        squash: true
      }
    },
    templateUrl: 'reports/outcomeTypes/totals',
    controller: 'OutcomeTypeTotalsReportController',
    controllerAs: '$ctrl',
    resolve: {
      config: resolveGlobalConfig
    }
  });
};

resolveGlobalConfig = function($stateParams, $state, program, OutcomeTypeReportService) {
  'ngInject';
  var program_id;
  program_id = program ? program.id : void 0;
  return OutcomeTypeReportService.getGlobalConfig($stateParams.outcome, $stateParams.value, program_id)["catch"](function() {
    return $state.go('.', {
      outcome: 'job'
    });
  });
};

OutcomeTypeReportService = (function() {

  /* @ngInject */
  function OutcomeTypeReportService($http, $timeout, ApiUrl) {
    this.http = $http;
    this.timeout = $timeout;
    this.ApiUrl = ApiUrl;
    this.url = ApiUrl.partial('reports', 'outcome-types');
  }

  OutcomeTypeReportService.prototype.getGlobalConfig = function(outcome, value, program_id) {
    var params, url;
    url = this.url(outcome + "-types", 'config');
    params = {
      value: value,
      program_id: program_id
    };
    return this.http.get(url, {
      params: params
    }).then(function(result) {
      return result.data;
    });
  };

  OutcomeTypeReportService.prototype.getGlobalTotals = function(outcome, params) {
    var url;
    url = this.url(outcome + "-types");
    return this.http.get(url, {
      params: params
    }).then(function(result) {
      return result.data;
    });
  };

  OutcomeTypeReportService.prototype.createDebounce = function(callback) {
    var timeoutPromise;
    timeoutPromise = null;
    return (function(_this) {
      return function() {
        _this.timeout.cancel(timeoutPromise);
        return timeoutPromise = _this.timeout(callback, 100);
      };
    })(this);
  };

  return OutcomeTypeReportService;

})();

OutcomeTypeReportBaseController = (function() {

  /* @ngInject */
  function OutcomeTypeReportBaseController($scope, program, TagRefreshService) {
    this.refresh = TagRefreshService.bindTagRefreshToScope($scope);
    this.program = program;
  }

  return OutcomeTypeReportBaseController;

})();

OutcomeTypeTotalsReportController = (function() {

  /* @ngInject */
  function OutcomeTypeTotalsReportController($state, $stateParams, $scope, config, program, OutcomeTypeReportService) {
    this.turnPage = bind(this.turnPage, this);
    this.tagChanged = bind(this.tagChanged, this);
    this.loadData = bind(this.loadData, this);
    this.state = $state;
    this.service = OutcomeTypeReportService;
    this.config = config;
    this.program = program;
    this.value = $stateParams.value || void 0;
    this.outcome = $stateParams.outcome;
    this.outcomeLabel = OutcomeTypes[this.outcome];
    if (!this.outcomeLabel) {
      $state.go('.', {
        outcome: 'job'
      });
    }
    this.sort = $stateParams.sort || this.config.name;
    this.page = $stateParams.page || 1;
    this.pager = null;
    this.link = this.getLink();
    $scope.$on('tagRefresh', this.tagChanged);
    $scope.$watch('$ctrl.pager.page', this.turnPage);
    this.triggerLoad = OutcomeTypeReportService.createDebounce(this.loadData);
    $scope.triggerRefresh();
  }

  OutcomeTypeTotalsReportController.prototype.getLink = function() {
    if (!this.value) {
      return '.';
    } else if (!this.program) {
      return 'program.reports.outcomeType.totals';
    } else if (this.program) {
      return 'student.overview';
    }
  };

  OutcomeTypeTotalsReportController.prototype.loadData = function() {
    var params;
    this.loading = true;
    params = angular.extend({}, this.tags, {
      program_id: this.program && this.program.id,
      sort: this.sort,
      value: this.value,
      page: this.value ? this.page : 1
    });
    this.state.go('.', params, {
      replace: true
    });
    return this.service.getGlobalTotals(this.outcome, params).then((function(_this) {
      return function(data) {
        _this.loading = false;
        _this.items = data.items;
        _this.pager = data.pager;
        return _this.total = data.total;
      };
    })(this));
  };

  OutcomeTypeTotalsReportController.prototype.tagChanged = function(event, tags) {
    if (!this.tags) {
      this.tags = tags;
      this.triggerLoad();
      return;
    }
    if (!angular.equals(tags, this.tags)) {
      this.tags = tags;
      this.turnPage(1);
      return this.triggerLoad();
    }
  };

  OutcomeTypeTotalsReportController.prototype.turnPage = function(page) {
    if (!page || page === this.page) {
      return;
    }
    this.page = page;
    return this.triggerLoad();
  };

  OutcomeTypeTotalsReportController.prototype.onSortChange = function() {
    this.page = 1;
    return this.triggerLoad();
  };

  return OutcomeTypeTotalsReportController;

})();

module.config(outcomeTypeStates);

module.service('OutcomeTypeReportService', OutcomeTypeReportService);

module.controller('OutcomeTypeTotalsReportController', OutcomeTypeTotalsReportController);

module.controller('OutcomeTypeReportBaseController', OutcomeTypeReportBaseController);
})(angular, angular.module("dybReports"));